import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { HttpEnum } from '@app/shared/enum/http.enum';

import Utils from '@app/shared/utils/utils';

export enum ResponseType {
  JSON = 'json',
  ARRAYBUFFER = 'arraybuffer',
  BLOB = 'blob',
  TEXT = 'text',
}

@Injectable()
export class HttpService {
  constructor(private _http: HttpClient) {}

  private _success(response: any) {
    if (!response.data) {
      return response;
    }

    return response.data;
  }

  private _error(error: Error) {
    return throwError(error);
  }

  private _makeBody(objBody = {}) {
    const arrayBody = Object.keys(objBody);
    let params = {};

    if (arrayBody.length) {
      arrayBody.forEach((key) => {
        params = {
          ...params,
          [Utils.camelToSnakeCase(key)]: objBody[key],
        };
      });
    }

    const newBody = new HttpParams({ fromObject: params });
    return newBody.toString();
  }

  put(url: string, data: any) {
    return this.request(HttpEnum.PUT, url, data).pipe(
      map((response) => this._success(response)),
      catchError((error) => this._error(error))
    );
  }

  post(url: string, data: any, header = {}, responseType = ResponseType.JSON) {
    return this.request(HttpEnum.POST, url, data, header, responseType).pipe(
      map((response) => this._success(response)),
      catchError((error) => this._error(error))
    );
  }

  get(url: string, data: any, responseType = ResponseType.JSON) {
    return this.request(HttpEnum.GET, url, data, undefined, responseType).pipe(
      map((response) => this._success(response)),
      catchError((error) => this._error(error))
    );
  }

  delete(url: string, data: any) {
    return this.request(HttpEnum.DELETE, url, data).pipe(
      map((response) => this._success(response)),
      catchError((error) => this._error(error))
    );
  }

  deleteWithBody(url: string, body: any) {
    return this._http.delete(url, { body }).pipe(
      map((response) => this._success(response)),
      catchError((error) => this._error(error))
    );
  }

  patch(url: string, data: any) {
    return this.request(HttpEnum.PATCH, url, data).pipe(
      map((response) => this._success(response)),
      catchError((error) => this._error(error))
    );
  }

  request(
    method: HttpEnum,
    url: string,
    params: any,
    header = {},
    responseType: ResponseType = ResponseType.JSON
  ) {
    const parseHeaders = Utils.removeEmptyFromObject(header);
    const baseConfig = {
      headers: new HttpHeaders(parseHeaders),
      responseType,
    } as any;

    if (method === HttpEnum.GET) {
      return this._http.get(url, {
        ...baseConfig,
        params,
      });
    } else if (method === HttpEnum.POST) {
      return this._http.post(url, params, {
        // TODO: Teste para contagem de upload no futuro
        // reportProgress: true,
        // observe: 'events',
        ...baseConfig,
      });
    } else if (method === HttpEnum.DELETE) {
      return this._http.delete(url, {
        ...baseConfig,
        body: params,
      });
    } else if (method === HttpEnum.PATCH) {
      return this._http.patch(url, params, {
        ...baseConfig,
      });
    }
    return this._http.put(url, params, {
      ...baseConfig,
    });
  }
}
